'use strict';

var CID = require('cids');

var configure = require('../lib/configure');

var _require = require('./utils'),
    findSources = _require.findSources;

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _findSources = findSources(args),
        sources = _findSources.sources,
        options = _findSources.options;

    var searchParams = new URLSearchParams(options.searchParams);
    sources.forEach(function (src) {
      return searchParams.append('arg', CID.isCID(src) ? "/ipfs/".concat(src) : src);
    });
    if (options.flush != null) searchParams.set('flush', options.flush);
    if (options.hashAlg) searchParams.set('hash', options.hashAlg);
    if (options.parents != null) searchParams.set('parents', options.parents);
    if (options.shardSplitThreshold != null) searchParams.set('shardSplitThreshold', options.shardSplitThreshold);
    return ky.post('files/cp', {
      timeout: options.timeout,
      signal: options.signal,
      headers: options.headers,
      searchParams: searchParams
    }).text();
  };
});